<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
        <g transform="translate(-1300 -196)">
            <!-- Background Circle -->
            <circle cx="1319" cy="215" r="19" fill="#383935"/>
            
            <!-- Move the lock upwards by shifting it in the Y direction -->
            <g transform="translate(0, -4)"> 
                <!-- Lock Body -->
                <path fill="#A5D867" d="M1316.1,213.5v2h-1.8v-2c0-2.7,2.1-4.8,4.8-4.8s4.8,2.1,4.8,4.8v2h-1.8v-2c0-1.8-1.5-3.2-3.2-3.2S1316.1,211.7,1316.1,213.5Z"/>

                <!-- Lock Shackle & Keyhole -->
                <path fill="#A5D867" d="M1323.5,219.2h-9.1c-1.1,0-2,0.9-2,2v4.2c0,1.1,0.9,2,2,2h9.1c1.1,0,2-0.9,2-2v-4.2C1325.5,220.1,1324.6,219.2,1323.5,219.2Zm-3.6,2.7c0.4,0.3,0.6,0.8,0.6,1.3s-0.2,1-0.6,1.3v1.5c0,0.5-0.4,1-1,1s-1-0.4-1-1v-1.5c-0.4-0.3-0.6-0.8-0.6-1.3s0.2-1,0.6-1.3c0.7-0.6,1.7-0.6,2.3,0Z"/>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'PrivacyIcon'
}
</script>

<style scoped>
    svg {
        width: 38px;
        height: 38px;
    }
</style>
